// @ts-nocheck
import setFixedHeader from "@store/Framework/Store/Bunzl/Components/Header/Handlers/SetFixedHeader";
import { HeaderIsFixedParameter } from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";
import { useDispatch } from "react-redux";

export default () => {
    const dispatch = useDispatch();

    return (parameter: HeaderIsFixedParameter) => {
        dispatch(setFixedHeader(parameter));
    };
};
